import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { accessToken } = useContext(AuthContext); //Get current token

  if (!accessToken) return <Navigate to="/" />; //If token doesn't exist, redirect to login
  return children;
};

export default ProtectedRoute;
